import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import Callout from '../../components/Callout';
import ComponentApi from '../../components/ComponentApi';
import ReactPlayground from '../../components/ReactPlayground';
import Basic from '../../examples/Accordion/Basic';
import AllCollapse from '../../examples/Accordion/AllCollapse';
import Flush from '../../examples/Accordion/Flush';
import CustomToggle from '../../examples/Accordion/CustomToggle.js';
import ContextAwareToggle from '../../examples/Accordion/ContextAwareToggle.js';
export const query = graphql`
  query AccordionQuery {
    Accordion: componentMetadata(displayName: { eq: "Accordion" }) {
      ...ComponentApi_metadata
    }
    AccordionItem: componentMetadata(displayName: { eq: "AccordionItem" }) {
      ...ComponentApi_metadata
    }
    AccordionHeader: componentMetadata(displayName: { eq: "AccordionHeader" }) {
      ...ComponentApi_metadata
    }
    AccordionBody: componentMetadata(displayName: { eq: "AccordionBody" }) {
      ...ComponentApi_metadata
    }
    AccordionButton: componentMetadata(displayName: { eq: "AccordionButton" }) {
      ...ComponentApi_metadata
    }
    AccordionCollapse: componentMetadata(
      displayName: { eq: "AccordionCollapse" }
    ) {
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <h1 {...{
      "id": "accordion"
    }}>{`Accordion`}</h1>
    <p className="lead">
  Build vertically collapsing accordions in combination with the Collapse
  component.
    </p>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`Click the accordions below to expand/collapse the accordion content.`}</p>
    <h3 {...{
      "id": "basic-example"
    }}>{`Basic Example`}</h3>
    <ReactPlayground codeText={Basic} mdxType="ReactPlayground" />
    <h3 {...{
      "id": "fully-collapsed-state"
    }}>{`Fully Collapsed State`}</h3>
    <p>{`If you want your `}<inlineCode parentName="p">{`Accordion`}</inlineCode>{` to start in a fully-collapsed state, then simply don't pass in a `}<inlineCode parentName="p">{`defaultActiveKey`}</inlineCode>{` prop to `}<inlineCode parentName="p">{`Accordion`}</inlineCode>{`.`}</p>
    <ReactPlayground codeText={AllCollapse} mdxType="ReactPlayground" />
    <h3 {...{
      "id": "flush"
    }}>{`Flush`}</h3>
    <p>{`Add `}<inlineCode parentName="p">{`flush`}</inlineCode>{` to remove the default background-color, some borders, and some rounded corners to render accordions edge-to-edge with their parent container.`}</p>
    <ReactPlayground codeText={Flush} mdxType="ReactPlayground" />
    <h2 {...{
      "id": "custom-accordions"
    }}>{`Custom Accordions`}</h2>
    <p>{`You can still create card-based accordions like those in Bootstrap 4. You can hook
into the Accordion toggle functionality via `}<inlineCode parentName="p">{`useAccordionButton`}</inlineCode>{` to make custom
toggle components.`}</p>
    <h3 {...{
      "id": "custom-toggle"
    }}>{`Custom Toggle`}</h3>
    <ReactPlayground codeText={CustomToggle} mdxType="ReactPlayground" />
    <h3 {...{
      "id": "custom-toggle-with-expansion-awareness"
    }}>{`Custom Toggle with Expansion Awareness`}</h3>
    <p>{`You may wish to have different styles for the toggle if it's associated section is expanded,
this can be achieved with a custom toggle that is context aware and also takes advantage of the `}<inlineCode parentName="p">{`useAccordionButton`}</inlineCode>{` hook.`}</p>
    <ReactPlayground codeText={ContextAwareToggle} mdxType="ReactPlayground" />
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.Accordion} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.AccordionItem} exportedBy={props.data.Accordion} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.AccordionHeader} exportedBy={props.data.Accordion} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.AccordionBody} exportedBy={props.data.Accordion} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.AccordionButton} exportedBy={props.data.Accordion} mdxType="ComponentApi" />
    <ComponentApi metadata={props.data.AccordionCollapse} exportedBy={props.data.Accordion} mdxType="ComponentApi" />
    <h3 {...{
      "id": "useaccordionbutton"
    }}>{`useAccordionButton`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useAccordionButton } from 'react-bootstrap/AccordionButton';

const decoratedOnClick = useAccordionButton(eventKey, onClick);
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      